import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '~env';
import { AuthModule } from './auth';
import { ErrorsModule } from './errors/errors.module';
import { LoaderModule } from './loader/loader.module';
import { LocalizedDatePipe } from './locale/localized-date.pipe';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { MonitoringModule } from './monitoring/monitoring.module';
import { NavigationModule } from './navigation/navigation.module';

@NgModule({ declarations: [LocalizedDatePipe], imports: [CommonModule,
        NgxsModule.forRoot([], { developmentMode: !environment.production }),
        !environment.production ? NgxsReduxDevtoolsPluginModule.forRoot() : [],
        MonitoringModule,
        AuthModule,
        TranslateModule,
        ErrorsModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        NavigationModule,
        LoaderModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
